import {Document, Page, View, Font, Text, Image} from "@react-pdf/renderer";
import RubikLight from "../../../../../../fonts/Rubik-Light.ttf";
import RubikRegular from "../../../../../../fonts/Rubik-Regular.ttf";
import RubikMedium from "../../../../../../fonts/Rubik-Medium.ttf";
import RubikBold from "../../../../../../fonts/Rubik-Bold.ttf";
import RubikBlack from "../../../../../../fonts/Rubik-Black.ttf";
import {styles } from "../../StylesPdfReport";
import moment from "moment";
import CoverPage from "../../shared/pdf/CoverPage";
import AboutSection from "./AboutSection";
import Chart from "../../shared/pdf/Chart";
import ChartSubsection from "../../shared/pdf/ChartSubsection";
import Units from "../../shared/pdf/Units";
import MarkGroup from "../../shared/pdf/MarkGroup";
import TableRow from "../../shared/pdf/TableRow";
import ChartNoteWrapperBig from "../../shared/pdf/ChartNoteWrapperBig";
import SubcategorySection from "../../shared/pdf/SubcategorySection";
import Plan from "./Plan";

Font.register({
    family: "Rubik",
    format: "truetype",
    fonts: [
        { src: RubikLight, fontWeight: 300 },
        { src: RubikRegular, fontWeight: 400 },
        { src: RubikMedium, fontWeight: 500 },
        { src: RubikBold, fontWeight: 700 },
        { src: RubikBlack, fontWeight: 800 },
    ],
});

const Report = ({ reportSummary, gradeLevels, graphData, skillsData }: any) => {

    return (
        <Document>
            <Page wrap size="A4" style={styles.body}>
                <View style={styles.coverBg}>
                    <CoverPage coverImage="/images/reports/cover-literatie-digitala.png" type="digitalLiteracy">
                        <View style={styles.titleCover}>
                            <Text style={styles.h1Peach}>Testul de literație digitală</Text>
                            <Text style={styles.h2Peach}>
                                Sesiune #{reportSummary.testId} / {reportSummary.testGradeName}
                            </Text>
                            <Text style={styles.h3Peach}>
                                Data: {moment(reportSummary.testStartedAt).locale("ro").format("DD MMMM YYYY")}
                            </Text>
                            <Text style={styles.h2}>
                                {reportSummary.studentName && `Elev: ${reportSummary.studentName}`}
                            </Text>
                        </View>
                    </CoverPage>
                    <View style={styles.wrapperCover}>
                        <AboutSection />
                        <View break style={styles.sectionAbout}>
                            <Text style={styles.h1}>Despre Scorul BRIO</Text>
                            <Chart
                                left={reportSummary.graphLeft}
                                bottom={reportSummary.graphBottom}
                                testScore={reportSummary.score}
                                segmentsImage={reportSummary.graphSegmentsImage}
                                big={true}
                                type="digitalLiteracy"
                            />
                            {gradeLevels.map((gradeLevel: any, index: any) => (
                                <View key={index}>
                                <ChartSubsection small={false} gradeLevel={gradeLevel} score={reportSummary.score} index={index} type="digitalLiteracy" />
                                </View>
                                    ))}
                        </View>
                        {graphData.length > 0 &&
                            <View break style={styles.sectionAbout}>
                                <Text style={styles.h1}>Profilul competențelor evaluate</Text>
                                <View style={styles.tableNote}>
                                    <View style={{ position: "relative" }}>
                                        <MarkGroup type="digitalLiteracy" />
                                        <View style={styles.gradesRow}>
                                            <View style={styles.colChapter}></View>
                                            <View style={[styles.colValues, { paddingBottom: "20pt" }]}>
                                                <Units type="digitalLiteracy"/>
                                            </View>
                                        </View>
                                        {graphData.map((section: any, index: any) => (
                                            <View key={index} >
                                            <TableRow section={section} index={index} />
                                            </View>
                                        ))}
                                    </View>
                                    <View style={[styles.gradesRow, { border: "none", marginTop: "7pt" }]}>
                                        <View style={styles.colChapter}></View>
                                        <View style={styles.colValues}>
                                            <View>
                                                <Image src="/images/reports/ld/chart-tabel.png" style={styles.chartTable} />
                                                <Units type="digitalLiteracy"/>
                                                <ChartNoteWrapperBig big={false} type="digitalLiteracy" />
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        }
                        <View style={styles.sectionAbout}>
                        {skillsData.length > 0 && (skillsData.map((skillData: any, index: any) => (
                            <View key={index}>
                                <SubcategorySection skillsData={skillData} key={index} type="digitalLiteracy" small={true}/>
                            </View>
                                ))
                        )}
                        </View>
                        <Plan />
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default Report;
